import React, { useState } from "react";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import _ from "lodash";

import { DropDownField, TextInputField } from "../../../helpers";
import { calculateBuyerQuotation, round } from "../../../utils";
import { useDispatch } from "react-redux";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

const measureOptions = [
    {label: 'Discount %', value: "Discount %"},
    {label: 'Margin %', value: "Margin %"}
]

const Commission = (props) => {
    const {buyerQuote, buyerQuoteItems, setBuyerQuoteItems, setBuyerQuote, selectedBuyerReqItemIds, setSelectedBuyerReqItemIds, setVisibleApprovals, buyerReq} = props

    const [delPeriod, setDelPeriod] = useState(null)
    const [measure, setMeasure] = useState("Margin %")
    const [measureValue, setMeasureValue] = useState(0)

    const dispatch = useDispatch()

    const buyerReqIds = _.uniqBy(_.map(buyerQuoteItems, "buyerReqItemId"))

    const allBuyerQuoteItemsChecked = selectedBuyerReqItemIds.length > 0 && selectedBuyerReqItemIds.length === buyerReqIds.length

    const handleSelectAll = (event) => {
        if(event.target.checked){
            setSelectedBuyerReqItemIds(buyerReqIds)
        } else {
            setSelectedBuyerReqItemIds([])
        }
    }

    const applyGlobalDelPeriod = () => {
        if (buyerReq.orderTypeId === 2) {
            return dispatch(raiseToast({ severity: 'error', summary: 'Error', detail: 'Delivery Period cannot be changed for Rate Contract Requirement', life: 3000 }))
        }

        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if(selectedBuyerReqItemIds.includes(eachBuyerQuoteItem.buyerReqItemId)){
                eachBuyerQuoteItem.leadTime = parseInt(delPeriod)
            }
            return eachBuyerQuoteItem
        })
        setBuyerQuoteItems(updatedBuyerQuoteItems)
        setSelectedBuyerReqItemIds([])
    }

    const applyGlobalMeasure = () => {
        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if(selectedBuyerReqItemIds.includes(eachBuyerQuoteItem.buyerReqItemId)){
                if(measure === "Discount %"){
                    const bQuotListPrice = eachBuyerQuoteItem.bQuotListPrice

                    const discountPercent = parseFloat(measureValue)
                    const discountAmount = (bQuotListPrice * discountPercent) / 100
                    const buyerUnitPrice = round(bQuotListPrice - discountAmount, 2)

                    const avgSellerPrice = eachBuyerQuoteItem.avgSellerPrice
                    const marginAmount = buyerUnitPrice - avgSellerPrice
                    const marginPercent = round((marginAmount / buyerUnitPrice) * 100, 2)

                    eachBuyerQuoteItem.bQuotDiscountRate = measureValue
                    eachBuyerQuoteItem.bQuotUnitPrice = buyerUnitPrice
                    eachBuyerQuoteItem.bQuotMarginRate = marginPercent
                }
                else if(measure === "Margin %"){
                    const avgSellerPrice = eachBuyerQuoteItem.avgSellerPrice
                    const bQuotListPrice = eachBuyerQuoteItem.bQuotListPrice

                    const marginPercent = parseFloat(measureValue)
                    //const marginAmount = (avgSellerPrice * marginPercent) / 100
                    const buyerUnitPrice = round(avgSellerPrice / (1 - (marginPercent / 100)), 2) // round(avgSellerPrice + marginAmount, 2)

                    const discountAmount = bQuotListPrice - buyerUnitPrice
                    const discountPercent = round((discountAmount / bQuotListPrice) * 100, 2)

                    eachBuyerQuoteItem.bQuotMarginRate = measureValue
                    eachBuyerQuoteItem.bQuotUnitPrice = buyerUnitPrice
                    eachBuyerQuoteItem.bQuotDiscountRate = discountPercent
                }
            }
            return eachBuyerQuoteItem
        })

        const calculatedResult = calculateBuyerQuotation(buyerQuote, updatedBuyerQuoteItems)
        setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)
        setSelectedBuyerReqItemIds([])
    }

    return(
        <div className="p-card mb-0 pb-2">
                <div className="grid">
                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 pb-0" >
                        <label style={{marginBottom:"5px", fontSize:"12px"}} >Select All</label>
                        <Checkbox checked={allBuyerQuoteItemsChecked} style={{textAlign:"center"}} onChange={handleSelectAll} ></Checkbox>
                    </div>
                        <div className="flex flex-column col-12 md:col-4 lg:col-1 w-5rem lg:mb-0">
                            <TextInputField name="delPeriod" labelText="Del. Period" value={delPeriod} onChange={(e) => setDelPeriod(e.target.value)} keyfilter="pnum" />  
                        </div>
                        <div className="flex flex-column lg:mb-0 md:col-4 lg:col-2 mt-3 w-6rem">
                            <Button label="APPLY" style={{backgroundColor:"#26a69a"}} onClick={applyGlobalDelPeriod} disabled={selectedBuyerReqItemIds.length == 0} /> {/* {...(allBuyerQuoteItemsChecked ? {} : {disabled: true})} */}
                        </div>
                        <div className="flex flex-column col-12 lg:col-2">
                            <DropDownField name="measure" options={measureOptions} value={measure} labelText="Measure" onChange={(e) => setMeasure(e.target.value)} {...buyerQuoteItems[0]?.buyerRateContractId ? {disabled: true} : {}} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-2 ml-0">
                            <TextInputField name="measureValue" labelText="Value" value={measureValue} onChange={(e)=>setMeasureValue(e.target.value)} {...buyerQuoteItems[0]?.buyerRateContractId ? {disabled: true} : {}} keyfilter="num" />
                        </div>
                        <div className="flex flex-column  mb-2 lg:mb-0 lg:col-2 pb- ml-0 mt-3 w-6rem">
                            <Button label="APPLY" style={{backgroundColor:"#26a69a"}} onClick={applyGlobalMeasure} disabled={selectedBuyerReqItemIds.length <= 0 || buyerQuoteItems[0]?.buyerRateContractId} />
                        </div>
                        <div className="flex flex-column  mb-2 lg:mb-0 md:col-12 lg:col-2 mt-3">
                            <Button label="Approvals" style={{backgroundColor:"#26a69a"}} onClick={() => setVisibleApprovals(true)} />
                        </div>
                    
                </div>
        </div>
    )
}

export default Commission;